<template>
  <button
    type="button"
    class="interactive-card shadow-sm category-card-anim"
    @click="$emit('card-click')"
  >
    <span class="card-glow-effect"></span>
    <button
      type="button"
      class="fav-action-btn"
      :class="{ 'is-fav': isFavorite, 'is-disabled': isDisabled }"
      :disabled="isDisabled"
      @click.stop="$emit('toggle-fav')"
      :title="isFavorite ? 'Quitar de favoritos' : (isDisabled ? 'Límite alcanzado' : 'Marcar favorito')"
    >
      <font-awesome-icon :icon="['fas', 'star']" />
    </button>
    <span class="card-icon-container anim-bounce">
      <img v-if="tool.img" :src="tool.img" :class="tool.id === 'ca' ? 'img-ca' : 'img-standard'" alt="Logo app">
      <font-awesome-icon v-else :icon="tool.icon" size="2x" :class="[tool.id === 'genericos' ? 'original-dark-text' : 'original-blue-text']" />
    </span>
    <span class="card-title-text mt-2">{{ tool.title }}</span>
  </button>
</template>

<script>
export default {
  name: 'ToolCard',
  props: {
    tool: {
      type: Object,
      required: true
    },
    isFavorite: {
      type: Boolean,
      default: false
    },
    canAddFavorite: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isDisabled() {
      return !this.isFavorite && !this.canAddFavorite;
    }
  }
}
</script>

<style scoped>
.original-blue-text {
  color: #163D7D !important;
}

.original-dark-text {
  color: #4a4b51 !important;
}

.interactive-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 1rem 0.5rem;
  text-align: center;
  position: relative;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 110px;
  max-height: 110px;
  width: 120px;
  max-width: 120px;
  flex: 0 0 120px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  appearance: none;
  outline: none;
}

.card-glow-effect {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at center, rgba(22, 61, 125, 0.08) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.interactive-card:hover {
  transform: translateY(-6px) scale(1.03);
  border-color: #163D7D;
  box-shadow: 0 15px 35px rgba(22, 61, 125, 0.15) !important;
}

.interactive-card:hover .card-glow-effect {
  opacity: 1;
}

.card-icon-container {
  margin-bottom: 6px;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 100%;
}

.interactive-card:hover .anim-bounce {
  animation: iconBounce 0.4s infinite alternate ease-in-out;
}

@keyframes iconBounce {
  0% {
    transform: translateY(0) scale(1.1);
  }
  100% {
    transform: translateY(-6px) scale(1.15);
  }
}

.fav-action-btn {
  position: absolute;
  top: 6px;
  right: 8px;
  color: #cbd5e1;
  font-size: 1.1rem;
  transition: color 0.2s, transform 0.2s;
  z-index: 3;
  line-height: 1;
  user-select: none;
  background: transparent;
  border: none;
  padding: 0;
  outline: none;
  cursor: pointer;
}

.fav-action-btn.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.fav-action-btn:hover:not(.is-disabled) {
  color: #f59e0b;
  cursor: pointer;
  transform: scale(1.3) rotate(15deg);
}

.fav-action-btn.is-fav {
  color: #f59e0b;
  filter: drop-shadow(0 0 5px rgba(245, 158, 11, 0.5));
}

.img-standard {
  height: 36px;
  max-height: 36px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

.img-ca {
  height: 35px;
  max-height: 35px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

.card-title-text {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  line-height: 1.2;
  padding: 0 4px;
  z-index: 2;
}

/* .category-card-anim {
  animation: popIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
} */
</style>